(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4514,4116,6368,582,5362,4342,5520,9279],{

/***/ 61527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "II": function() { return /* reexport */ Input; },
  "Ph": function() { return /* reexport */ Select; },
  "gx": function() { return /* reexport */ Textarea; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(8683);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(11717);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 2 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(71618);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/foundation.js
var foundation = __webpack_require__(90593);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/icon/Icon.js
var Icon = __webpack_require__(55803);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/icon/IconList.js
var IconList = __webpack_require__(34898);
;// CONCATENATED MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/form/Input.js
var __makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};






var inputCSS = function (isDisabled) { return function (theme) {
    return (0,emotion_react_browser_esm.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", "px;\n    outline: none;\n    border: none;\n    padding: ", "px;\n    display: flex;\n    align-items: center;\n    background-color: ", ";\n    border-radius: ", "px;\n\n    i + input,\n    input + i {\n      margin-left: ", "px;\n    }\n\n    input {\n      border: none;\n      outline: none;\n      flex-grow: 1;\n      width: 100px;\n      background-color: transparent;\n      color: ", ";\n\n      &:disabled {\n        color: ", ";\n        // iOS Safari fix\n        -webkit-text-fill-color: ", ";\n        opacity: 1;\n      }\n\n      &::placeholder {\n        color: ", ";\n      }\n    }\n\n    button {\n      padding: 4px;\n      margin: -4px;\n      border: none;\n      background-color: transparent;\n      font-size: 0;\n      margin-left: ", "px;\n    }\n  "], ["\n    font-size: ", "px;\n    outline: none;\n    border: none;\n    padding: ", "px;\n    display: flex;\n    align-items: center;\n    background-color: ", ";\n    border-radius: ", "px;\n\n    i + input,\n    input + i {\n      margin-left: ", "px;\n    }\n\n    input {\n      border: none;\n      outline: none;\n      flex-grow: 1;\n      width: 100px;\n      background-color: transparent;\n      color: ", ";\n\n      &:disabled {\n        color: ", ";\n        // iOS Safari fix\n        -webkit-text-fill-color: ", ";\n        opacity: 1;\n      }\n\n      &::placeholder {\n        color: ", ";\n      }\n    }\n\n    button {\n      padding: 4px;\n      margin: -4px;\n      border: none;\n      background-color: transparent;\n      font-size: 0;\n      margin-left: ", "px;\n    }\n  "])), foundation/* FontSizes.medium */.TS.medium, foundation/* Spacing.medium */.Ki.medium, isDisabled ? theme.var.gray100 : theme.var.gray50, foundation/* Radius.medium */.wU.medium, foundation/* Spacing.xsmall */.Ki.xsmall, theme.var.black, theme.var.gray400, theme.var.gray400, theme.var.gray600, foundation/* Spacing.xxsmall */.Ki.xxsmall);
}; };
var Input = (0,react.forwardRef)(function (_a, ref) {
    var className = _a.className, icon = _a.icon, value = _a.value, onClear = _a.onClear, props = __rest(_a, ["className", "icon", "value", "onClear"]);
    var disabled = props.disabled;
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    return ((0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", __assign({ className: className, css: inputCSS(disabled !== null && disabled !== void 0 ? disabled : false) }, { children: [icon, (0,emotion_react_jsx_runtime_browser_esm.jsx)("input", __assign({ ref: ref, value: value }, props)), onClear && value && !disabled && ((0,emotion_react_jsx_runtime_browser_esm.jsx)("button", __assign({ onClick: onClear, type: "button" }, { children: (0,emotion_react_jsx_runtime_browser_esm.jsx)(Icon/* default */.Z, { icon: IconList/* XCircle */.IW, size: foundation/* Sizes.small */.u8.small, color: theme.var.gray500 }) })))] })));
});
/* harmony default export */ var form_Input = ((/* unused pure expression or super */ null && (Input)));
var templateObject_1;
//# sourceMappingURL=Input.js.map
;// CONCATENATED MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/css.js
var css_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var multiline = (0,emotion_react_browser_esm.css)(css_templateObject_1 || (css_templateObject_1 = css_makeTemplateObject(["\n  line-height: 135%;\n  white-space: pre-line;\n  word-break: break-all;\n"], ["\n  line-height: 135%;\n  white-space: pre-line;\n  word-break: break-all;\n"])));
var ellipsis = (0,emotion_react_browser_esm.css)(templateObject_2 || (templateObject_2 = css_makeTemplateObject(["\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  line-height: 135%;\n"], ["\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  line-height: 135%;\n"])));
var css_templateObject_1, templateObject_2;
//# sourceMappingURL=css.js.map
;// CONCATENATED MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/form/Select.js
var Select_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var Select_assign = (undefined && undefined.__assign) || function () {
    Select_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return Select_assign.apply(this, arguments);
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};







var selectWrapCSS = function (fontSize) { return function (theme) {
    return (0,emotion_react_browser_esm.css)(Select_templateObject_1 || (Select_templateObject_1 = Select_makeTemplateObject(["\n    position: relative;\n    user-select: none;\n    font-size: ", "px;\n\n    ul {\n      position: absolute;\n      width: 100%;\n      top: 0;\n      background-color: ", ";\n      border-radius: ", "px;\n      max-height: 180px;\n      overflow: auto;\n      box-shadow: 0 1px 10px rgba(0, 0, 0, 0.2);\n      z-index: 9;\n      transition: 0.1s ease-out;\n      transform: scale(1);\n\n      &.hidden {\n        opacity: 0;\n        visibility: hidden;\n        transform: scale(0.9);\n      }\n\n      li {\n        padding: ", "px;\n        cursor: pointer;\n\n        &.selected {\n          color: #45b7d0;\n        }\n      }\n    }\n  "], ["\n    position: relative;\n    user-select: none;\n    font-size: ", "px;\n\n    ul {\n      position: absolute;\n      width: 100%;\n      top: 0;\n      background-color: ", ";\n      border-radius: ", "px;\n      max-height: 180px;\n      overflow: auto;\n      box-shadow: 0 1px 10px rgba(0, 0, 0, 0.2);\n      z-index: 9;\n      transition: 0.1s ease-out;\n      transform: scale(1);\n\n      &.hidden {\n        opacity: 0;\n        visibility: hidden;\n        transform: scale(0.9);\n      }\n\n      li {\n        padding: ", "px;\n        cursor: pointer;\n\n        &.selected {\n          color: #45b7d0;\n        }\n      }\n    }\n  "])), fontSize, theme.var.gray50, foundation/* Radius.medium */.wU.medium, foundation/* Spacing.medium */.Ki.medium);
}; };
var selectCSS = function (isDisabled) { return function (theme) {
    return (0,emotion_react_browser_esm.css)(Select_templateObject_2 || (Select_templateObject_2 = Select_makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    padding: ", "px;\n    background-color: ", ";\n    border-radius: ", "px;\n    cursor: ", ";\n\n    p {\n      flex-grow: 1;\n      padding-right: ", "px;\n      color: ", ";\n    }\n  "], ["\n    display: flex;\n    align-items: center;\n    padding: ", "px;\n    background-color: ", ";\n    border-radius: ", "px;\n    cursor: ", ";\n\n    p {\n      flex-grow: 1;\n      padding-right: ", "px;\n      color: ", ";\n    }\n  "])), foundation/* Spacing.medium */.Ki.medium, isDisabled ? theme.var.gray100 : theme.var.gray50, foundation/* Radius.medium */.wU.medium, isDisabled ? 'not-allowed' : 'pointer', foundation/* Spacing.small */.Ki.small, isDisabled ? theme.var.gray400 : theme.var.black);
}; };
var Select = function (_a) {
    var className = _a.className, name = _a.name, selected = _a.selected, placeholder = _a.placeholder, options = _a.options, optionStyle = _a.optionStyle, _b = _a.fontSize, fontSize = _b === void 0 ? foundation/* FontSizes.medium */.TS.medium : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, onClick = _a.onClick, onChange = _a.onChange;
    var _d = __read((0,react.useState)(false), 2), isOpen = _d[0], setOpen = _d[1];
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    var handleSelect = (0,react.useCallback)(function (option) {
        onChange === null || onChange === void 0 ? void 0 : onChange(option);
        setOpen(false);
    }, []);
    return ((0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", Select_assign({ className: className, css: selectWrapCSS(fontSize) }, { children: [(0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", Select_assign({ css: selectCSS(disabled), onClick: disabled ? undefined : onClick !== null && onClick !== void 0 ? onClick : (function () { return setOpen(function (prev) { return !prev; }); }) }, { children: [(0,emotion_react_jsx_runtime_browser_esm.jsx)("p", Select_assign({ css: ellipsis }, { children: selected ? selected.label : placeholder })), (0,emotion_react_jsx_runtime_browser_esm.jsx)(Icon/* default */.Z, { icon: isOpen ? IconList/* ArrowUp */.a2 : IconList/* ArrowDown */.K5, size: foundation/* Sizes.small */.u8.small, color: disabled ? theme.var.gray400 : theme.var.black })] })), (0,emotion_react_jsx_runtime_browser_esm.jsx)("ul", Select_assign({ className: isOpen ? undefined : 'hidden', style: optionStyle }, { children: options === null || options === void 0 ? void 0 : options.map(function (option) { return ((0,emotion_react_jsx_runtime_browser_esm.jsx)("li", Select_assign({ onClick: function () { return handleSelect(option); }, className: (selected === null || selected === void 0 ? void 0 : selected.value) === option.value ? 'selected' : undefined }, { children: (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", Select_assign({ css: multiline }, { children: option.label })) }), "select-".concat(name, "-").concat(option.value))); }) }))] })));
};
/* harmony default export */ var form_Select = ((/* unused pure expression or super */ null && (Select)));
var Select_templateObject_1, Select_templateObject_2;
//# sourceMappingURL=Select.js.map
// EXTERNAL MODULE: ./.yarn/__virtual__/react-textarea-autosize-virtual-b25d8b70b8/0/cache/react-textarea-autosize-npm-8.5.3-27299c7990-b317c3763f.zip/node_modules/react-textarea-autosize/dist/react-textarea-autosize.browser.esm.js + 3 modules
var react_textarea_autosize_browser_esm = __webpack_require__(84490);
;// CONCATENATED MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/form/Textarea.js
var Textarea_makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var Textarea_assign = (undefined && undefined.__assign) || function () {
    Textarea_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return Textarea_assign.apply(this, arguments);
};
var Textarea_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};





var textareaCSS = function (fontSize, minHeight, isDisabled) {
    return function (theme) {
        return (0,emotion_react_browser_esm.css)(Textarea_templateObject_1 || (Textarea_templateObject_1 = Textarea_makeTemplateObject(["\n      min-height: ", "px;\n      padding: ", "px;\n      border-radius: ", "px;\n      background-color: ", ";\n\n      textarea {\n        display: block;\n        width: 100%;\n        resize: none;\n        border: none;\n        outline: none;\n        font-size: ", "px;\n        background-color: transparent;\n        color: ", ";\n\n        &:disabled {\n          color: ", ";\n          // iOS Safari fix\n          -webkit-text-fill-color: ", ";\n          opacity: 1;\n        }\n\n        &::placeholder {\n          color: ", ";\n        }\n      }\n    "], ["\n      min-height: ", "px;\n      padding: ", "px;\n      border-radius: ", "px;\n      background-color: ", ";\n\n      textarea {\n        display: block;\n        width: 100%;\n        resize: none;\n        border: none;\n        outline: none;\n        font-size: ", "px;\n        background-color: transparent;\n        color: ", ";\n\n        &:disabled {\n          color: ", ";\n          // iOS Safari fix\n          -webkit-text-fill-color: ", ";\n          opacity: 1;\n        }\n\n        &::placeholder {\n          color: ", ";\n        }\n      }\n    "])), minHeight, foundation/* Spacing.medium */.Ki.medium, foundation/* Radius.medium */.wU.medium, isDisabled ? theme.var.gray100 : theme.var.gray50, fontSize, theme.var.black, theme.var.gray400, theme.var.gray400, theme.var.gray600);
    };
};
var Textarea = (0,react.forwardRef)(function (_a, ref) {
    var className = _a.className, _b = _a.fontSize, fontSize = _b === void 0 ? foundation/* FontSizes.medium */.TS.medium : _b, props = Textarea_rest(_a, ["className", "fontSize"]);
    var minRows = props.minRows, disabled = props.disabled;
    var _minRows = minRows !== null && minRows !== void 0 ? minRows : 3;
    var minHeight = _minRows * (fontSize + 2) + 2;
    return ((0,emotion_react_jsx_runtime_browser_esm.jsx)("div", Textarea_assign({ className: className, css: textareaCSS(fontSize, minHeight, disabled !== null && disabled !== void 0 ? disabled : false) }, { children: (0,emotion_react_jsx_runtime_browser_esm.jsx)(react_textarea_autosize_browser_esm/* default */.Z, Textarea_assign({ ref: ref }, props)) })));
});
/* harmony default export */ var form_Textarea = ((/* unused pure expression or super */ null && (Textarea)));
var Textarea_templateObject_1;
//# sourceMappingURL=Textarea.js.map
;// CONCATENATED MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/form/index.js



//# sourceMappingURL=index.js.map

/***/ }),

/***/ 12293:
/***/ (function(module) {

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

module.exports = baseSum;


/***/ }),

/***/ 47304:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSum = __webpack_require__(12293),
    identity = __webpack_require__(37174);

/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */
function sum(array) {
  return (array && array.length)
    ? baseSum(array, identity)
    : 0;
}

module.exports = sum;


/***/ }),

/***/ 74001:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
"use client";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/InView.tsx


// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
function getRootId(root) {
  if (!root)
    return "0";
  if (RootIds.has(root))
    return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  let id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id, observer, elements } = createObserver(options);
  let callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    __publicField(this, "node", null);
    __publicField(this, "_unobserveCb", null);
    __publicField(this, "handleNode", (node) => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({ inView: !!this.props.initialInView, entry: void 0 });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({ inView, entry });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve();
    this.observeNode();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip)
      return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(
      this.node,
      this.handleChange,
      {
        threshold,
        root,
        rootMargin,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      },
      fallbackInView
    );
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const { children } = this.props;
    if (typeof children === "function") {
      const { inView, entry } = this.state;
      return children({ inView, entry, ref: this.handleNode });
    }
    const {
      as,
      triggerOnce,
      threshold,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return React.createElement(
      as || "div",
      { ref: this.handleNode, ...props },
      children
    );
  }
};

// src/useInView.tsx

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const callback = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(
    () => {
      if (skip || !ref)
        return;
      let unobserve;
      unobserve = observe(
        ref,
        (inView, entry) => {
          setState({
            inView,
            entry
          });
          if (callback.current)
            callback.current(inView, entry);
          if (entry.isIntersecting && triggerOnce && unobserve) {
            unobserve();
            unobserve = void 0;
          }
        },
        {
          root,
          rootMargin,
          threshold,
          // @ts-ignore
          trackVisibility,
          // @ts-ignore
          delay
        },
        fallbackInView
      );
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      // eslint-disable-next-line react-hooks/exhaustive-deps
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

//# sourceMappingURL=index.mjs.map

/***/ })

}]);